import happyGroup from "../components/images/office.jpeg";
import img1 from "../components/images/infra/img1.jpg";
import img2 from "../components/images/infra/img2.jpg";
import img3 from "../components/images/infra/img3.jpg";
import img4 from "../components/images/infra/img4.jpg";
import img5 from "../components/images/infra/img5.jpg";
import img6 from "../components/images/infra/img6.jpg";
import img7 from "../components/images/infra/img7.jpg";
import img8 from "../components/images/infra/img8.jpg";
import img9 from "../components/images/infra/img9.jpg";

const Infrastructure = () => {
  return (
    <div>
      <div
        className="carousel header"
        style={{ backgroundImage: `url(${happyGroup})`, height: "500px" }}
      >
        <div className="carousel-content">
          <div>
            <h1>INFRASTRUCTURE</h1>
          </div>
        </div>
      </div>
      
      <div className="gallary-container">
        <h1>Our Infrastructure</h1>
        <div className="gallary-cards">
            <div className="gallary-card">
                <img src={img1}/>
            </div>
            <div className="gallary-card">
                <img src={img2}/>
            </div>
            <div className="gallary-card">
                <img src={img3}/>
            </div>
            <div className="gallary-card">
                <img src={img4}/>
            </div>
            <div className="gallary-card">
                <img src={img5}/>
            </div>
            <div className="gallary-card">
                <img src={img6}/>
            </div>
            <div className="gallary-card">
                <img src={img7}/>
            </div>
            <div className="gallary-card">
                <img src={img8}/>
            </div>
            <div className="gallary-card">
                <img src={img9}/>
            </div>

        </div>       
      </div>
    </div>
  );
};

export default Infrastructure;
